import { render } from "./SingleSaleCatalogy.vue?vue&type=template&id=2f5cebc8&scoped=true"
import script from "./SingleSaleCatalogy.vue?vue&type=script&lang=js"
export * from "./SingleSaleCatalogy.vue?vue&type=script&lang=js"

import "./SingleSaleCatalogy.vue?vue&type=style&index=0&id=2f5cebc8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5cebc8"]])

export default __exports__